/**
 * Flags ace-web reads off the BFF. The BFF namespaces every flag per service,
 * so each of these maps to `ace-web.<name>` upstream - see `FLAG_KEY_PREFIX`.
 */
export enum FeatureFlags {
  maintenance = 'maintenance',
  /** Cross-service flags are shared with other services, so they are not namespaced per service */
  referrals = 'cross.ace_referral_program',
  use_enhanced_charts = 'cross.use-enhanced-charts',
}

export enum FlagEnvironment {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  TEST = 'TEST',
  UAT = 'UAT',
  PROD = 'PROD',
}

export type BffFlag = {
  enabled: boolean;
  payload?: Record<string, any>;
};

export type BffFlagsResponse = {
  flags: Record<string, BffFlag>;
  streamCursor?: string;
};

export type FlagStreamEvent = {
  key: string;
  enabled?: boolean;
  payload?: Record<string, any>;
};

export type FeatureFlagValue = {
  enabled: boolean;
  value: Record<string, any> | null;
};

export type FeatureFlagMap = Partial<Record<FeatureFlags, FeatureFlagValue>> & Record<string, FeatureFlagValue>;

export type RequestedFeatureFlags = Record<FeatureFlags, FeatureFlagValue>;
